import { useAtom } from 'jotai';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { AiOutlineRise } from 'react-icons/ai';
import { CgClose } from 'react-icons/cg';
import { FaRegLightbulb } from 'react-icons/fa';
import {
  HiArrowCircleLeft,
  HiArrowCircleRight,
  HiChevronDown,
} from 'react-icons/hi';
import { useBoolean, useStep } from 'usehooks-ts';

import { rudderstackTrackEvent } from '@/api/rudderstack/client';
import { ErorrsAtom } from '@/lib/store';
import Button from '@/tayara-kit/Button';
import Text from '@/tayara-kit/Text';

import CelebrateAndBoostStep from './CelebrateAndBoostStep';
import ConfirmationDialog from './ConfirmationDialog';
import CriteriasStep from './CrtieriasStep';
import DetailsStep from './DetailsStep';
import useCreateAdHook from '../../hooks/useNewAdHook';

// Overflow scroll component
const OverflowYScroll = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => (
  <div className="h-full w-full overflow-x-hidden overflow-y-auto pt-16 md:pt-16 lg:pt-14 p-1 md:p-6 rounded-md">
    {children}
  </div>
);

interface PostListingFlowProps {
  isPage?: boolean;
}

type IFlow = {
  [key: string]: JSX.Element;
};

const PostListingFlow: React.FC<PostListingFlowProps> = () => {
  const [
    stepIndex,
    { goToNextStep, goToPrevStep, canGoToPrevStep, canGoToNextStep },
  ] = useStep(3);
  const { push } = useRouter();

  const {
    category,

    subcategory,

    listSubcategory,
    images,
    setImages,
    governorate,
    updateGovernorate,
    listDelegation,
    title,
    setTitle,
    description,
    setDesciption,
    price,
    setPrice,
    categoryList,
    selectCategory,
    selectSubCategory,
    paramsList,
    updateSelectedOptions,
    setDelegation,
    delegation,
    phoneNumber,
    setphoneNumber,
    startPostProcess,
    verifyInputForStep,
    updateErrors,
    resetErrors,
    showConfirmDialog,
    setShowConfirmDialog,
    useOwnPhone,
    setUseOnwPhone,
    selectedParamsList,
    newAdId,
    newAdLoader,
    productType,
    setProductType,
  } = useCreateAdHook(goToNextStep);

  const steps: IFlow = {
    details: (
      <DetailsStep
        category={category}
        subcategory={subcategory}
        categoryList={categoryList}
        price={price}
        setPrice={setPrice}
        listSubcategory={listSubcategory}
        title={title}
        setTitle={setTitle}
        description={description}
        setDesciption={setDesciption}
        selectCategory={selectCategory}
        selectSubCategory={selectSubCategory}
        productType={productType}
        selectProductType={setProductType}
        listparams={paramsList}
        updateSelectedOptions={updateSelectedOptions}
        selectedParamsList={selectedParamsList}
        images={images}
        setImages={setImages}
        editMode={false}
        adDetails={''}
      />
    ),
    contact: (
      <CriteriasStep
        canGoToPrevStep={canGoToPrevStep}
        governorate={governorate}
        updateGovernorate={updateGovernorate}
        listDelegation={listDelegation}
        setdelegation={setDelegation}
        delegation={delegation}
        phoneNumber={phoneNumber}
        setphoneNumber={setphoneNumber}
        startPostProcess={startPostProcess}
        useOwnPhone={useOwnPhone}
        setUseOnwPhone={setUseOnwPhone}
      />
    ),
    celebrate: (
      <div className="">
        <div className="mx-auto">
          <CelebrateAndBoostStep />
        </div>
        {/* Action booster l'annonce */}
        <div className="flex justify-center items-center flex-col gap-y-4">
          {/* Action booster l'annonce */}
          {!canGoToNextStep && (
            <button
              onClick={() =>
                push({
                  pathname: `/boost/${newAdId}`,
                })
              }
              className="w-[70vw] md:mr-0 md:w-[30vw] flex flex-col items-center justify-center  rounded-xl border-[1.5px] border-yellow-300 bg-gradient-to-tr from-yellow-300 via-orange-400 to-orange-300 text-white text-base font-extrabold hover:from-yellow-500 hover:to-orange-500 group shadow-sm  hover:shadow-none"
            >
              <div className=" flex mx-2 md:mx-3 lg:mx-10 xl:mx-20 gap-x-2 md:gap-x-3 lg:gap-x-2 items-center">
                <AiOutlineRise
                  className="group-hover:animate-rocking mt-1"
                  size={38}
                />
                <div className="w-full mx-auto flex flex-col my-3 pr-4 md:pr-0">
                  <span className="text-base font-semibold mb-1 leading-none md:leading-6">
                    Boostez votre annonce
                  </span>
                  <span className="tracking-widest uppercase text-xs font-normal leading-none md:leading-4 ">{`" Bi3 Fissa3 "`}</span>
                </div>
              </div>
            </button>
          )}
          <Link
            href={`/item/${newAdId}`}
            replace
            passHref
            className="w-full flex justify-center"
          >
            <button className="w-[70vw] md:w-[30vw] flex flex-col items-center justify-center  rounded-xl text-gray-700 text-base font-extrabold group ">
              <div className=" flex mx-2 md:mx-3 lg:mx-10 xl:mx-20 gap-x-2 md:gap-x-3 lg:gap-x-2 items-center">
                <div className="w-full mx-auto flex flex-col my-3 pr-4 md:pr-0">
                  <span className="text-base font-semibold leading-6 truncate">
                    Consulter l&rsquo;annonce
                  </span>
                </div>
                <HiArrowCircleRight
                  className="group-hover:animate-go-right mt-1"
                  size={24}
                />
              </div>
            </button>
          </Link>
        </div>
      </div>
    ),
  };
  const isExpandedinLargeScreen = window.innerWidth >= 1024; // Adjust the screen width threshold as needed

  const { value: isExpanded, toggle: toggleExpanded } = useBoolean(true);

  const isExpandedCondition = isExpandedinLargeScreen
    ? isExpanded === true
    : isExpanded === false;

  const celebrateStep = Object.keys(steps)[2];

  function scrollToTop() {
    window.scrollTo({
      top: 0, // Scroll to the top of the page
      behavior: 'smooth', // You can use 'auto' or 'smooth' for scrolling behavior
    });
  }

  const navigateToStep = (callback: Function, index: number) => {
    if (verifyInputForStep(Object.keys(steps)[stepIndex - 1] as string)) {
      // if (
      //   Object.keys(steps)[stepIndex - 1] === 'details' &&
      //   paramsList.length === 0
      // ) {
      //   callback(index + 1);
      // }

      resetErrors();

      callback(index);
      push(
        {
          pathname: '/post-listing/',
          query: { postStep: Object.keys(steps)[stepIndex + 0] },
        },
        undefined,
        { shallow: true }
      );

      rudderstackTrackEvent(
        `Ad Insertion Step ${Object.keys(steps)[stepIndex - 1]}`
      );
      scrollToTop();
    } else {
      updateErrors({
        tabName: `newAd_${Object.keys(steps)[stepIndex - 1]}`,
        message: 'Veuillez remplir tout le formulaire!',
      });
    }
  };

  // const [DisplaySuccess, DisplayError] = useDisplayMessage(
  //   `${Object.keys(steps)[stepIndex - 1]}`,
  //   'newAd'
  // );

  const errors = useAtom(ErorrsAtom);

  return (
    <div className="">
      {showConfirmDialog && (
        <ConfirmationDialog
          onCLickClose={() => setShowConfirmDialog(undefined)}
          title={showConfirmDialog.title}
          onClickAccept={showConfirmDialog.onClickConfirm}
          description={showConfirmDialog.description}
        />
      )}

      {/* Head bar */}
      <div className="w-full lg:w-[95vw]  fixed z-50 top-[10rem] md:top-[140px] p-0 md:px-6 bg-white lg:bg-neutral-50">
        {/* Head bar */}
        <div className="w-[95%] md:w-[93%] flex justify-between mt-12 md:mt-10">
          <div className="flex gap-x-5 lg:gap-x-10 justify-center items-center flex-col md:flex-row">
            <Text
              as="h1"
              text="Créer une annonce"
              className="font-bold text-primary text-xl"
            />
          </div>
          <span
            className={`text-2xs lg:text-sm font-bold mt-1 rounded-md p-1 text-primary`}
          >
            {errors[0].newAd_contact || errors[0].newAd_details}
          </span>
          <div>
            <Link href={'/'} replace passHref className="w-full ">
              <Button
                aria-label="Quitter"
                className={
                  'bg-gray-200 btn-sm hover:bg-secondary text-gray-700 hover:text-white'
                }
                icon={<CgClose size={16} />}
              >
                <Text text="Quitter" className="hidden md:hidden xl:block" />
              </Button>
            </Link>
          </div>
        </div>

        {/* steps progress bar */}
        <div className="w-[95%] mt-4 relative h-1 bg-gray-100">
          <div
            className={`absolute h-full w-full inset-0 origin-left transition-transform
          ${!canGoToNextStep ? 'bg-lime-500' : 'bg-primary'}`}
            style={{
              transform: `scaleX(${(1 / 3) * stepIndex})`,
            }}
          ></div>
        </div>
      </div>

      {/* Body */}
      <OverflowYScroll>
        <div className=" grid grid-cols-6 w-full ">
          <div
            className={` p-2 md:p-8 bg-gray-50 order-2 xl:order-1 ${
              celebrateStep ? 'xl:col-span-4' : 'xl:col-span-6'
            } col-span-full `}
          >
            {Object.values(steps)[stepIndex - 1]}
            {/* Previous and next Actions */}
            <div className="w-full flex items-center justify-end gap-x-4 my-4 md:my-10">
              {canGoToNextStep && (
                <Button
                  aria-label="Retour"
                  aria-disabled={!canGoToPrevStep}
                  icon={<HiArrowCircleLeft />}
                  className={`
              w-fit xl:w-[20rem] btn-secondary
              ${
                !canGoToPrevStep
                  ? 'disabled bg-gray-200 border-none text-gray-400 pointer-events-none'
                  : ''
              }`}
                  onClick={() => {
                    if (
                      Object.keys(steps)[stepIndex - 1] === 'photos' &&
                      paramsList.length === 0
                    ) {
                      goToPrevStep();
                    }
                    goToPrevStep();
                    resetErrors();
                  }}
                >
                  Retour
                </Button>
              )}

              {canGoToNextStep && (
                <Button
                  aria-label={
                    stepIndex === Object.keys(steps).length - 1
                      ? 'Publier'
                      : 'Suivant'
                  }
                  disabled={newAdLoader}
                  loading={newAdLoader}
                  aria-disabled={!canGoToNextStep}
                  icon={<HiArrowCircleRight />}
                  className={`w-fit xl:w-[20rem] btn-primary ${
                    !canGoToNextStep
                      ? 'bg-gray-200 text-gray-400 pointer-events-none border-none'
                      : ''
                  }`}
                  onClick={() =>
                    stepIndex === Object.keys(steps).length - 1
                      ? startPostProcess()
                      : navigateToStep(goToNextStep, stepIndex)
                  }
                >
                  {newAdLoader && (
                    <svg
                      className="animate-spin h-5 w-5 mr-3 "
                      viewBox="0 0 24 24"
                    ></svg>
                  )}
                  {stepIndex === Object.keys(steps).length - 1
                    ? 'Publier'
                    : 'Suivant'}
                </Button>
              )}
            </div>
            <Text
              as="span"
              text={'Tous les champs contenant (*) sont obligatoires'}
              className="my-2 text-xs font-light text-gray-800"
            />
          </div>
          {/* Tayara advices */}
          {celebrateStep && (
            <div className="xl:fixed w-full order-1 xl:order-2 xl:w-1/6 top-52 xl:top-48 right-56 xl:py-6 col-span-full xl:col-span-2">
              <div className="flex flex-col justify-center items-center w-full xl:w-fit h-fit p-4 md:p-0 my-4">
                <div className="flex flex-col w-full justify-end items-center">
                  <Text
                    as="span"
                    text={'Comment bien présenter mon annonce?'}
                    className="flex md:flex xl:hidden my-4 italic text-sm xl:text-base font-bold text-gray-800"
                  />

                  <div className="flex grow justify-between items-center">
                    <div className="mx-4 w-[8rem] h-[1px] bg-yellow-400"></div>
                    <FaRegLightbulb className="text-yellow-400" size={22} />
                    <div className="mx-4 w-[8rem] h-[1px] bg-yellow-400"></div>
                  </div>
                  <button
                    className="flex md:flex xl:hidden text-xs items-center gap-x-1 text-primary font-medium my-2"
                    onClick={() => toggleExpanded()}
                  >
                    <Text
                      as="span"
                      text={`${
                        isExpanded
                          ? 'Afficher les conseils tayara'
                          : 'Masquer les conseils tayara'
                      }`}
                      className="text-neutral-700 font-light"
                    />
                    <HiChevronDown
                      size={22}
                      className={`${
                        isExpanded ? '' : 'rotate-180'
                      } text-neutral-700 `}
                    />
                  </button>
                </div>
                {isExpandedCondition && (
                  <div className="text-gray-700 my-2 ">
                    <p className="flex flex-col text-center text-xs 2xl:text-sm font-light text-gray-900 px-2">
                      <span className="mt-2">
                        <span className="italic text-sm xl:text-base font-semibold">
                          Mettez en avant les détails importants!
                        </span>
                        <br /> Plus vous fournissez de détails, plus votre
                        annonce sera de qualité, ce qui peut attirer davantage
                        d`acheteurs intéressés.
                        <br />
                      </span>

                      <span className="mt-2">
                        <span className="italic text-sm xl:text-base font-semibold">
                          Soyez juste dans votre tarification!
                        </span>
                        <br />
                        Soyez honnête dans votre tarification, tout en gardant à
                        l&rsquo;esprit que la négociation est possible.
                        <br />
                      </span>

                      <span className="mt-2">
                        <span className="italic text-sm xl:text-base font-semibold">
                          Plus de photos, plus d`efficacité!
                        </span>
                        <br /> N`hésitez pas à ajouter autant de photos que
                        possible pour donner une vue complète de votre produit
                        ou service.
                        <br />
                      </span>
                      <span className="mt-2">
                        <span className="italic text-sm xl:text-base font-semibold">
                          Soyez accessible!
                        </span>
                        <br /> Un numéro de téléphone valide est essentiel pour
                        faciliter les échanges avec les acheteurs potentiels et
                        renforcer la confiance.
                        <br />
                      </span>
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </OverflowYScroll>
      {/* End Body */}
    </div>
  );
};
export default PostListingFlow;
